import { SVGProps, Ref, forwardRef } from 'react';

export const CraneFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M9 20c0 1.885 0 2.828-.586 3.414C7.828 23.999 6.886 24 5 24c-1.767 0-2.707 0-3.3-.483l-.114-.103C1 22.828 1 21.885 1 20V9.32h8z"
            fill="currentColor"
        />
        <path
            d="M16.9 11.526c1.302.015 2.03.095 2.514.58.586.585.586 1.528.586 3.413s0 2.829-.586 3.414c-.586.586-1.528.586-3.414.586-1.767 0-2.707 0-3.3-.482l-.114-.104C12 18.348 12 17.404 12 15.52s0-2.828.586-3.414c.484-.484 1.212-.564 2.514-.579V9.32h1.8z"
            fill="currentColor"
        />
        <path
            d="M1.719.38c.718-.599 1.812-.4 3.997-.003L9 .973V7.52H1v-4c.01-1.701.092-2.615.719-3.138"
            fill="currentColor"
        />
        <path d="M21.21 3.194a2.18 2.18 0 0 1-.167 4.314l-.224.011H10.8V1.301z" fill="currentColor" />
    </svg>
));
CraneFilledSize24Glyph.displayName = 'CraneFilledSize24Glyph';
